<template>
  <div class="dropdown">
    <div  class="dropdown-button">
     <span> {{ selectedOption }}</span> <span style="width: 20px" :class="{'rotate': props.isOpen}">
        <img style="margin-top: 2px;" :src="arrow_down" alt="" >
      </span>
    </div>
      <ul  
         :class="['dropdown-menu',{'is-active':props.isOpen}]"
      >
        <li 
          v-for="option in options" 
          :key="option.value" 
          @click="selectOption(option)"
          class="dropdown-item"
        >
         {{ option.label }}
        </li>
      </ul>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import arrow_down from '~/assets/images/arrow-down.svg';

const emit = defineEmits(['handleSortBy','setOnSort']);
const isOpen = ref(false);
const selectedOption = ref('Latest');

const options = [
  // { value: 'most_similar', label: 'MOST SIMILAR' },
  { value: 'latest', label: 'Latest',content:'Latest' },
  { value: 'price-low-to-high', label: 'Price Low to High',content:'Low to High' },
  { value: 'price-high-to-low', label: 'Price High to Low',content:'High to Low' },
  { value: 'bestsellers', label: 'Best Sellers',content:'Best Sellers' },
];
const props = defineProps({
  isOpen: Boolean,
  selected: String
});

if( props.selected ) {
  const selected = options.find(option => option.value === props.selected );
  if( selected ) {
    selectedOption.value = selected.label;
  }
}
const selectOption = (option: { value: string, label: string,content:string }) => {
  selectedOption.value = option.content;
  isOpen.value = false;

  emit('handleSortBy', option.value);
  emit('setOnSort');
};
</script>

